import { useEffect, useState } from 'react';

/**
 * Se o formulário mudou desde que o diálogo abriu.
 *
 * Os modais marcavam `dirty` de dois jeitos errados: não marcavam (Esc perdia
 * tudo o que se digitou) ou marcavam por "tem valor" (o pedido que já nasce com
 * itens, a baixa que já nasce com o valor), e pediam confirmação para fechar sem
 * alteração nenhuma — o que ensina a clicar em "descartar" sem ler.
 *
 * O retrato é tirado UM render depois de abrir: os modais que preenchem o
 * formulário num efeito (ao receber o registro) já estão preenchidos quando ele
 * é tirado, e não nascem "Não salvo".
 *
 * @param valor o que o formulário tem agora — qualquer coisa que vire JSON.
 * @param aberto o que identifica esta abertura: o registro em edição, `'novo'`,
 *   ou `true`. Falso fecha; mudar de valor tira outro retrato.
 */
export function useAlteracaoPendente(valor: unknown, aberto: unknown): boolean {
    const atual = JSON.stringify(valor);
    /* A abertura é comparada pelo conteúdo: `{ alvo, fornecedores }` montado no
       render é um objeto novo a cada vez, e por identidade retrataria sem parar. */
    const abertura = aberto ? JSON.stringify(aberto) : null;
    const [retrato, setRetrato] = useState<string | null>(null);
    const [retratar, setRetratar] = useState(false);

    useEffect(() => {
        setRetrato(null);
        setRetratar(abertura !== null);
    }, [abertura]);

    useEffect(() => {
        if (!retratar) return;
        setRetrato(atual);
        setRetratar(false);
    }, [retratar, atual]);

    return retrato !== null && retrato !== atual;
}
